import { Component, OnInit, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LaudoUnionService } from 'src/app/services/http/laudo-union.service';

@Component({
  selector: 'app-modal-editar-vistoriador',
  templateUrl: './modal-editar-vistoriador.component.html',
  styleUrls: ['./modal-editar-vistoriador.component.scss']
})
export class ModalEditarVistoriadorComponent implements OnInit {


  vistoriador = new FormControl({value: '', disabled: true}, [Validators.required])


  @Input() cabecalho: string;
  @Input() id: number;
  justificativa = new FormControl('', [Validators.required]);
  listaVistoriador: any[] =[];
  errorMessage = '';

  constructor(
    private laudoService: LaudoUnionService,
    public activeModal: NgbActiveModal) { }

  ngOnInit() {
    this.laudoService.getListaVistoriador(this.id).then(r => {
      this.listaVistoriador = r;
      if (this.listaVistoriador.length > 0) {
        this.vistoriador.enable();
        this.errorMessage = '';
      } else {
        this.errorMessage = 'Unidade sem vistoriador cadastrado.';
      }
    });
  }
}
